import { render, staticRenderFns } from "./WrongQuestion.vue?vue&type=template&id=63186e90&scoped=true"
import script from "./WrongQuestion.vue?vue&type=script&lang=js"
export * from "./WrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./WrongQuestion.vue?vue&type=style&index=0&id=63186e90&prod&lang=less&scoped=true"
import style1 from "./WrongQuestion.vue?vue&type=style&index=1&id=63186e90&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63186e90",
  null
  
)

export default component.exports